<div class="dashboard-layout">
  
  <!-- SIDEBAR -->
  <aside class="dashboard-sidebar">
    <div class="sidebar-brand" (click)="navigateTo('overview')" style="display: flex; align-items: center; gap: 12px; cursor: pointer;">
      <app-logo size="sm"></app-logo>
      <div style="border-left: 1px solid var(--border-color); padding-left: 12px; height: 24px; display: flex; align-items: center;">
        <span class="logo-text gradient-text" style="font-family: 'Nunito', sans-serif; font-size: 1.25rem; font-weight: 800; letter-spacing: -0.01em; white-space: nowrap;">Partner</span>
      </div>
    </div>

    <div class="sidebar-node-status">
      <span class="status-dot online"></span>
      <span class="node-id-label" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap; font-weight: 600; font-size: 0.85rem;" [title]="partnerService.companyName()">{{ partnerService.companyName() }}</span>
    </div>

    <nav class="sidebar-menu">
      <div class="menu-section-header" style="margin-top: 0;">Overview</div>
      <ul class="menu-list" style="margin-bottom: 12px;">
        <li [class.active]="isActive('overview')" (click)="navigateTo('overview')">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="9"></rect><rect x="14" y="3" width="7" height="5"></rect><rect x="14" y="12" width="7" height="9"></rect><rect x="3" y="16" width="7" height="5"></rect></svg>
          Dashboard
        </li>
      </ul>

      <div class="menu-section-header">Compliance</div>
      <ul class="menu-list" style="margin-bottom: 12px;">
        <li [class.active]="isActive('users')" (click)="navigateTo('users')">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
          User Management
        </li>
        <li [class.active]="isActive('transactions')" (click)="navigateTo('transactions')">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line></svg>
          Transactions
        </li>
      </ul>

      <div class="menu-section-header">Integrations</div>
      <ul class="menu-list">
        <li [class.active]="isActive('api-management')" (click)="navigateTo('api-management')">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="2" width="20" height="8" rx="2" ry="2"></rect><rect x="2" y="14" width="20" height="8" rx="2" ry="2"></rect><line x1="6" y1="6" x2="6.01" y2="6"></line><line x1="6" y1="18" x2="6.01" y2="18"></line></svg>
          API Management
        </li>
        <li [class.active]="isActive('settings')" (click)="navigateTo('settings')">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
          Security
        </li>
        <li [class.active]="isActive('profile')" (click)="navigateTo('profile')">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
          Account Profile
        </li>
      </ul>
    </nav>
  </aside>

  <!-- MAIN DASHBOARD CONTENT AREA -->
  <main class="dashboard-main">
    <header class="dashboard-header">
      <div>
        <h2>Hashbooks Partner Console</h2>
        <p style="font-size: 0.9rem; color: var(--text-muted);">Secure multi-party financial clearing dashboard.</p>
      </div>
      <div class="dashboard-header-actions" style="display:flex; align-items:center; gap:20px; position: relative;">
        <div class="uptime-badge">
          <span class="status-dot online animated-pulse"></span>
          Uptime 99.99%
        </div>
        <div class="current-date" style="font-size: 0.85rem; color: var(--text-dim);">
          May 18, 2026
        </div>

        <!-- Spacer Divider -->
        <div style="width: 1px; height: 20px; background: var(--border-color);"></div>

        <!-- Theme Toggle -->
        <button (click)="partnerService.toggleTheme()" style="background: none; border: none; cursor: pointer; display: flex; align-items: center; padding: 4px; color: var(--text-dim); outline: none; transition: transform 0.2s ease;" title="Toggle Theme">
          @if (partnerService.isDarkMode()) {
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line></svg>
          } @else {
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path></svg>
          }
        </button>

        <!-- Notification Bell -->
        <div class="notification-bell-container" style="position: relative; cursor: pointer; display: flex; align-items: center; padding: 4px;">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="color: var(--text-dim);"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
          <span class="notification-badge">9</span>
        </div>

        <!-- User Profile Dropdown -->
        <div class="user-profile-dropdown-wrapper" style="position: relative; display: flex; align-items: center;">
          <button class="user-avatar-circle" (click)="toggleDropdown($event)" style="background: var(--primary); padding: 0; border: 2px solid var(--primary); width: 38px; height: 38px; border-radius: 50%; cursor: pointer; display: flex; align-items: center; justify-content: center; outline: none; transition: all 0.2s ease;">
            <span style="color: white; font-weight: 800; font-size: 0.85rem; font-family: var(--font-display); letter-spacing: 0.05em;">{{ emailInitials }}</span>
          </button>

          <!-- Dropdown Container -->
          @if (isDropdownOpen()) {
            <div class="header-dropdown-menu" (click)="$event.stopPropagation()">
              <div class="dropdown-user-info" style="display: flex; align-items: center; gap: 12px; padding: 16px;">
                <div style="width: 42px; height: 42px; border-radius: 50%; background: var(--primary); display: flex; align-items: center; justify-content: center; border: 2px solid var(--primary); flex-shrink: 0;">
                  <span style="color: white; font-weight: 800; font-size: 0.95rem; font-family: var(--font-display); letter-spacing: 0.05em;">{{ emailInitials }}</span>
                </div>
                <div style="display: flex; flex-direction: column; overflow: hidden; text-align: left;">
                  <span style="font-weight: 700; color: var(--text-main); font-size: 0.92rem; font-family: var(--font-display); line-height: 1.2;">{{ userName }}</span>
                  <span style="font-size: 0.78rem; color: var(--text-dim); text-overflow: ellipsis; overflow: hidden; white-space: nowrap; margin-top: 2px;">{{ userEmail }}</span>
                </div>
              </div>

              <div style="height: 1px; background: var(--border-color); margin: 0;"></div>

              <ul class="dropdown-list" style="list-style: none; margin: 0; padding: 6px 0;">
                <li class="dropdown-item" (click)="navigateTo('profile'); closeDropdown()">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                  My Profile
                </li>
                <li class="dropdown-item" (click)="navigateTo('settings'); closeDropdown()">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>
                  Settings
                </li>
                <li class="dropdown-item" (click)="partnerService.showToast('Support Center coming soon.'); closeDropdown()">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
                  Help
                </li>
                <li class="dropdown-item logout-item" (click)="handleLogout(); closeDropdown()">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
                  Logout
                </li>
              </ul>
            </div>
          }
        </div>
      </div>
    </header>

    <div class="dashboard-content-panel">
      <!-- Child page templates rendered inside router-outlet -->
      <router-outlet></router-outlet>
    </div>
  </main>

</div>

<!-- Global AI chat widget — DEFERRED: Phase 3 (RAG architecture) -->
<app-chat-widget></app-chat-widget>
